import { formatCount } from './helpers';

interface SummaryStatProps {
    label: string;
    value: number | null | undefined;
    tone?: string;
}

const SummaryStat = ({ label, value, tone = 'neutral' }: SummaryStatProps) => {
    const toneClass =
        tone === 'good' ? 'text-green-400' : tone === 'warn' ? 'text-yellow-400' : tone === 'bad' ? 'text-red-400' : 'text-white';

    return (
        <div>
            <div className="text-xs text-zinc-500">{label}</div>
            <div className={`text-lg font-semibold ${toneClass}`}>{formatCount(value)}</div>
        </div>
    );
};

export default SummaryStat;
